<script setup lang="ts" generic="T extends string">
/**
 * A row of mutually exclusive buttons: the By model / By competitor switch and the
 * chart's range.
 */
defineProps<{
    options: Array<{ value: T; label: string }>
    modelValue: T
}>()

const emit = defineEmits<{
    'update:modelValue': [value: T]
}>()
</script>

<template>
    <div class="inline-flex items-center gap-0.5 rounded-lg border bg-muted/40 p-0.5" role="tablist">
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            role="tab"
            :aria-selected="option.value === modelValue"
            class="rounded-md px-3 py-1 text-xs font-medium transition-colors"
            :class="
                option.value === modelValue
                    ? 'bg-background text-foreground ring-1 ring-border'
                    : 'text-muted-foreground hover:text-foreground'
            "
            @click="emit('update:modelValue', option.value)"
        >
            {{ option.label }}
        </button>
    </div>
</template>
